import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        // mode: 'light',
        // primary: {
        //     main: '#fff',
        // },
        // secondary: {
        //     main: '#dc004e',
        // },
        // background: {
        //     default: '#ffffff', // white background
        //     // paper: '#f5f5f5', // light grey background for paper components
        // },
        // text: {

        // },
    },
});

export default theme;